import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=a8e045a2&scoped=true&"
import script from "./Prompt.vue?vue&type=script&lang=js&"
export * from "./Prompt.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-prompt.scss?vue&type=style&index=0&id=a8e045a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e045a2",
  null
  
)

export default component.exports